export default "/images/1a745f7e0dcacaeeb40352385c3420c6.avif";